module.exports = __webpack_public_path__ + "img/Garder.21e7c080.png";